export default {
    "recent_activity":"Activité récente",
    "you_have_unfinished_invoice":"Vous avez une facture non terminée",
    "you_have_unfinished_estimate":"Vous avez un devis non terminé",
    "invoice":"Facture",
    "estimate":"Devis",
    "home":"Accueil",
    "document":"Document",
    "client":"Client",
    "report":"Rapport",
    "new":"Nouveau",
    "no_client_found":"Aucun client trouvé.",
    "search":"Rechercher",
    "clients":"Clients",
    "documents":"Documents",
    "no_document_found":"Aucun document trouvé.",
    "cancel":"Annuler",
    "new_client":"Nouveau client",
    "add_client":"Ajouter un client",
    "client_name_is_required":"Le nom du client est requis !",
    "client_name":"Nom du client",
    "email":"E-mail",
    "phone":"Téléphone",
    "mobile":"Mobile",
    "fax":"Fax",
    "address":"Adresse",
    "address_1":"Adresse 1",
    "address_2":"Adresse 2",
    "city":"Ville",
    "state_province":"État/Province",
    "zip_postal_code":"Code postal",
    "country":"Pays",
    "filter_documents":"Filtrer les documents",
    "apply_filter":"Appliquer le filtre",
    "document_type":"Type de document",
    "all":"Tous",
    "send_state":"État d'envoi",
    "sent":"Envoyé",
    "not_sent":"Non envoyé",
    "payment_state":"État du paiement",
    "paid":"Payé",
    "not_paid":"Non payé",
    "overdue":"En retard",
    "date":"Date",
    "this_month":"Ce mois-ci",
    "this_year":"Cette année",
    "custom":"Personnalisé",
    "from":"De",
    "to":"À",
    "preview":"Aperçu",
    "summary":"Résumé",
    "estimate_number":"Numéro de devis",
    "issued":"Émis",
    "valid_until":"Valable jusqu'au",
    "history":"Historique",
    "show":"Afficher",
    "share":"Partager",
    "print":"Imprimer",
    "download_pdf":"Télécharger PDF",
    "send_estimate":"Envoyer le devis",
    "document_history":"Historique du document",
    "mark_as_paid":"Marquer comme payé",
    "paid":"Payé",
    "invoice_number":"Numéro de facture",
    "due":"Échéance",
    "send_invoice":"Envoyer la facture",
    "new_item":"Nouvel article",
    "name":"Nom",
    "price":"Prix",
    "item_name":"Nom de l'article",
    "item_price":"Prix de l'article",
    "item_name_is_required":"Le nom de l'article est requis !",
    "item_price_is_required":"Le prix de l'article est requis !",
    "item_tax_state":"État fiscal de l'article",
    "add_item":"Ajouter un article",
    "new_service":"Nouveau service",
    "unit":"Unité (Heure, Jour)",
    "service_name_is_required":"Le nom du service est requis !",
    "service_price_is_required":"Le prix du service est requis !",
    "tax":"Taxe",
    "service_tax_state":"État fiscal du service",
    "add_service":"Ajouter un service",
    "items_and_services":"Articles et services",
    "items":"Articles",
    "item":"Article",
    "services":"Services",
    "update_item":"Mettre à jour l'article",
    "are_you_sure":"Êtes-vous sûr ?",
    "this_action_will_delete_the_item":"Cette action supprimera l'article.",
    "delete":"Supprimer",
    "update":"Mettre à jour",
    "update_service":"Mettre à jour le service",
    "this_action_will_delete_the_service":"Cette action supprimera le service.",
    "business":"Entreprise",
    "business_details":"Détails de l'entreprise",
    "business_details_1":"Détails de l'entreprise",
    "business_logo":"Logo de l'entreprise",
    "business_name":"Nom de l'entreprise",
    "business_name_is_required":"Le nom de l'entreprise est requis !",
    "mobile_number":"Numéro de portable",
    "mobile_number_2":"Numéro de portable 2",
    "website":"Site web",
    "street":"Rue",
    "street_2":"Rue 2",
    "save":"Enregistrer",
    "settings":"Paramètres",
    "business_settings":"Paramètres de l'entreprise",
    "payment_options":"Options de paiement",
    "tax_settings":"Paramètres fiscaux",
    "document_settings":"Paramètres des documents",
    "template_design_and_settings":"Conception et paramètres du modèle",
    "app_settings":"Paramètres de l'application",
    "language":"Langue",
    "theme":"Thème",
    "dark":"Sombre",
    "light":"Clair",
    "auto":"Auto",
    "subscription":"Abonnement",
    "rate_us":"Évaluez-nous",
    "paypal_email_is_required":"L'email PayPal est requis",
    "online_payments":"Paiements en ligne",
    "paypal":"PayPal",
    "paypal_email":"Email PayPal",
    "stripe":"Stripe",
    "payment_instructions":"Instructions de paiement",
    "add_instructions":"Ajoutez des instructions pour être payé :\n- informations de compte bancaire.\n- Venmo, Zelle, Cash App.\n- autres informations.",
    "apply_tax_to_documents":"Appliquer la taxe aux documents",
    "tax_label":"Étiquette de la taxe",
    "option_1":"Option 1 (%)",
    "option_2":"Option 2 (%)",
    "option_3":"Option 3 (%)",
    "itemsandservices":"Articles&Services",
    "preview_and_customize":"Aperçu et personnalisation",
    "new_estimate":"Nouveau devis",
    "add_itemandservice":"Ajouter article/service",
    "sub-total":"Sous-total",
    "discount":"Remise",
    "total":"Total",
    "estimate_notes":"Notes du devis",
    "create_estimate":"Créer un devis",
    "new_invoice":"Nouvelle facture",
    "invoice_notes":"Notes de la facture",
    "create_invoice":"Créer une facture",
    "client_details":"Détails du client",
    "save_changes":"Enregistrer les modifications",
    "remove_this_client_from_the_document":"Supprimer ce client du document !",
    "contact":"Contact",
    "update_invoice":"Mettre à jour la facture",
    "item_details":"Détails de l'article",
    "remove_this_item_from_the_document":"Supprimer cet article du document !",
    "quantity":"Quantité",
    "item_quantity_is_required!":"La quantité de l'article est requise !",
    "total_price":"Prix total",
    "service_details":"Détails du service",
    "remove_this_service_from_the_document":"Supprimer ce service du document !",
    "unit_type":"Type d'unité",
    "service_quantity_is_required":"La quantité du service est requise",
    "select_terms":"Sélectionner les conditions",
    "taxable":"Imposable",
    "non_taxable":"Non imposable",
    "total_estimates":"Total des devis",
    "total_invoices":"Total des factures",
    "service_name":"Nom du service",
    "service_price":"Prix du service",
    "no_item_found":"Aucun article trouvé.",
    "no_service_found":"Aucun service trouvé.",
    "select_your_language":"Sélectionnez votre langue",
    "stripe_invoice_link":"Lien de facture Stripe",
    "update_estimate":"Mettre à jour le devis",
    "sub_total":"Sous-total",
    "select_a_currency":"Sélectionnez une devise",
    "reports":"Rapports",
    "customize":"Personnaliser",
    "edit":"Modifier",
    "invoices":"Factures",
    "estimates":"Devis",
    "get_statement":"Obtenir un relevé",
    "no_client_found_with_the_given_id":"Aucun client trouvé avec l'ID donné.",
    "no_statement_found":"Aucun relevé trouvé",
    "no_document_found_for_this_client":"Aucun document trouvé pour ce client.",
    "client_statment":"Relevé client",
    "send_statment":"Envoyer le relevé",
    "update_client":"Mettre à jour le client",
    "remove_this_item":"Supprimer cet article",
    "remove_this_service":"Supprimer ce service",
    "set_as_default":"Définir par défaut",
    "top_invoiced_clients":"CLIENTS LES PLUS FACTURÉS",
    "amount":"Montant",
    "invoices_up":"FACTURES",
    "quarter":"Trimestre",
    "unpaid":"Non payé",
    "top_invoiced_items":"ARTICLES LES PLUS FACTURÉS",
    "quantity_up":"Quantité",
    "top_invoiced_services":"SERVICES LES PLUS FACTURÉS",
    "last_year":"L'année dernière",
    "life_time":"Durée de vie",
    "ok":"OK",
    "invoice_send_template_subject":"Facture #{document_number} de {business_name}",
    "invoice_send_template_email":"Bonjour {client_name},\n \nJ'espère que vous allez bien.\n \nNous avons émis une nouvelle facture (#{document_number}) de {business_name}.\n \nVous pouvez la consulter ou la télécharger en toute sécurité via le lien ci-dessous :\n \n🔗 https://snapbill.app/document/{document_id}\n \nSi vous avez des questions concernant cette facture ou besoin d'assistance, n'hésitez pas à nous contacter à {business_email}.\n \nMerci de votre confiance en {business_name}.\n \nNous apprécions votre collaboration !\n \nCordialement,\n \nL'équipe {business_name}",
    "estimate_send_template_subject":"Devis #{document_number} de {business_name}",
    "estimate_send_template_email":"Bonjour {client_name},\n \nJ'espère que vous allez bien.\n \nNous avons préparé un devis (#{document_number}) de {business_name} pour votre examen.\n \nVous pouvez le consulter ou le télécharger en toute sécurité via le lien ci-dessous :\n \n🔗 https://snapbill.app/document/{document_id}\n \nSi vous avez des questions, souhaitez apporter des modifications ou souhaitez aller de l'avant, répondez simplement à cet e-mail ou contactez-nous à {business_email}.\n \nMerci d'avoir considéré {business_name}.\n \nNous sommes impatients de travailler avec vous !\n \nCordialement,\n \nL'équipe {business_name}",
    "statement_send_template_subject":"Relevé de {business_name}",
    "statement_send_template_email":"Bonjour {client_name},\n \nJ'espère que vous allez bien.\n \nVotre dernier relevé de {business_name} est maintenant disponible.\nCe relevé fournit un résumé de vos factures et devis pour votre examen.\n \nVous pouvez le consulter ou le télécharger en toute sécurité via le lien ci-dessous :\n \n🔗 https://snapbill.app/statement/{statment_number}\n \nSi vous avez des questions concernant ce relevé ou avez besoin de plus de détails, n'hésitez pas à nous contacter à {business_email}.\n \nMerci de votre confiance en {business_name}.\n \nCordialement,\n \nL'équipe {business_name}",
    "no_internet_connection":"Pas de connexion Internet",
    "you_need_an_internet_connection_to_send_or_share_your_invoice":"Vous avez besoin d'une connexion Internet pour envoyer ou partager votre facture.\nVeuillez vérifier votre connexion et réessayer plus tard, ou choisissez une des options hors ligne (Imprimer ou Télécharger en PDF) pour continuer.",
    "you_need_an_internet_connection_to_send_or_share_your_estimate":"Vous avez besoin d'une connexion Internet pour envoyer ou partager votre devis.\nVeuillez vérifier votre connexion et réessayer plus tard, ou choisissez une des options hors ligne (Imprimer ou Télécharger en PDF) pour continuer.",
    "you_need_an_internet_connection_to_send_or_share_your_statment":"Vous avez besoin d'une connexion Internet pour envoyer ou partager votre relevé.\nVeuillez vérifier votre connexion et réessayer plus tard, ou choisissez une des options hors ligne (Imprimer ou Télécharger en PDF) pour continuer.",
    "error":"Erreur",
    "mail_composer_is_not_available_on_this_device":"Le rédacteur de courrier n'est pas disponible sur cet appareil",
    "estimate_full_capital":"DEVIS",
    "invoice_full_capital":"FACTURE",
    "estimate_to":"DEVIS À",
    "invoice_to":"FACTURE À",
    "invoice_no":"N° de facture :",
    "issue_date":"Date d'émission :",
    "due_date":"Date d'échéance :",
    "valid_until":"Valable jusqu'au :",
    "description":"Description",
    "unit_price":"Prix unitaire",
    "note":"Remarque :",
    "number_1":"Numéro 1",
    "number_2":"Numéro 2",
    "bill_to":"Facturer à",
    "from_full_capital":"DE",
    "details_full_capital":"DÉTAILS",
    "valid": "Valide",
    "select_contact": "Sélectionner un contact",
    "no_contacts": "Aucun contact trouvé",
    "import_from_contacts": "Importer depuis les contacts",
    "call": "Appeler",
    "message": "Message",
    "success": "Succès",
    "pdf_saved": "PDF enregistré ! Ouvrez Fichiers → Sur mon iPhone → SnapBill",
    "not_send": "Non envoyé",
    "created": "Créé",
    "send_to": "Envoyer à",
    "signatures": "Signatures",
    "signature": "Signature",
    "new_signature": "Nouvelle signature",
    "signature_name_is_required": "Le nom de la signature est requis",
    "clear": "Effacer",
    "delete_signature": "Supprimer la signature",
    "this_action_will_delete_the_signature": "Cette action supprimera la signature.",
    "no_signatures_found": "Aucune signature trouvée",
    "add_your_signature": "Ajoutez votre signature",
    "this_action_will_remove_the_signature_from_this_document": "Cette action supprimera la signature de ce document.",
    "on_receipt": "À la réception",
    "three_days": "3 jours",
    "ten_days": "10 jours",
    "thirty_days": "30 jours",
    "no_duo_date": "Aucune date d’échéance",
    "no_valid_date": "Aucune date valide",
    "select_date": "Sélectionner une date",
    "percentage": "Pourcentage",
    "fix": "Fixe",
    "please_add_client_detail_to_the_invoice": "Veuillez ajouter les informations du client à la facture",
    "please_add_at_least_one_item_to_the_invoice": "Veuillez ajouter au moins un article à la facture",
    "please_add_client_detail_to_the_estimate": "Veuillez ajouter les informations du client au devis",
    "please_add_at_least_one_item_to_the_estimate": "Veuillez ajouter au moins un article au devis",
    "next": "Suivant",
    "get_started": "Commencer",
    "create_invoices_and_estimates_in_seconds": "Créez des factures et des devis en quelques secondes",
    "auto_fill_client_details": "Renseignez automatiquement les informations du client, appliquez des modèles et envoyez en moins de 20 secondes.",
    "get_paid_faster_and_know_it_instantly": "Soyez payé plus vite et informé instantanément",
    "snapbill_notifies_you_the_moment": "SnapBill vous avertit dès que vos clients ouvrent votre facture ou commencent le paiement. Plus de suppositions, seulement des mises à jour en temps réel et un meilleur flux de trésorerie.",
    "see_your_business_in_full_color": "Découvrez votre entreprise en couleurs",
    "visualize_income_trends": "Visualisez les tendances de revenus, suivez les factures en retard et identifiez vos meilleurs clients grâce à des rapports clairs et intelligents qui vous aident à grandir en toute confiance.",
    "unlimited_access": "Accès illimité",
    "not_sure_yet": "Pas encore sûr ?",
    "enable_free_access": "Activer l'accès gratuit",
    "best_offer": "Meilleure offre",
    "yearly_plan": "Abonnement annuel",
    "per_week": "par semaine",
    "three_days_free_trail": "3 jours d’essai gratuit",
    "weekly_plan": "Abonnement hebdomadaire",
    "countinue_with_three_days_free": "Continuer avec 3 jours gratuits",
    "countinue_with_best_offer": "Continuer avec la meilleure offre",
    "privacy": "Confidentialité",
    "already_subscribed": "Déjà abonné ?",
    "terms": "Conditions",
    "please_select_different_plan": "Veuillez sélectionner un autre abonnement",
    "your_current_plan": "Votre abonnement actuel",
    "statment_of_account": "Relevé de compte",
    "statment_date": "Date du relevé",
    "classic": "Classique",
    "modern": "Moderne",
    "wave": "Wave",
    "estimate_no": "Devis n° :",
    "pay_now":"Payez maintenant",
    "copy":"Copie",
    "copied":"Copié",
    "invalid_stripe_invoice_link":"Lien de facture Stripe invalide",
    "client_name_viewed_your_invoice_document_number":"{client_name} a consulté votre facture n° {document_number}",
    "client_name_viewed_your_estimate_document_number":"{client_name} a consulté votre devis n° {document_number}",
    "client_name_started_paying_invoice":"{client_name} a commencé le paiement de la facture n° {document_number} via {payment_method}",
    "good_news":"Bonne nouvelle !"
}